<template>
  <div v-loading="logoutLoading" class="home">
    <div class="home-header">
      <div class="left">
        <div class="home-icon">
          <img style="height: 34px" :src="loginIcon" alt="" />
        </div>
        <div class="home-name">{{ getAppName(appName) }}</div>
      </div>
      <div class="right">
        <el-popover width="240" trigger="click" popper-class="account-popper">
          <template #reference>
            <div class="account-icon">
              <img
                width="32px"
                :src="
                  accountInfo.loginInfo ? accountInfo.loginInfo.avatarUrl : ''
                "
                alt="avatarUrl"
              />
            </div>
          </template>
          <div class="account">
            <div class="account-name">
              {{
                (accountInfo.loginInfo && accountInfo.loginInfo.email) ||
                `+${accountInfo.loginInfo && accountInfo.loginInfo.areaCode}
              ${accountInfo.loginInfo && accountInfo.loginInfo.phone}`
              }}
            </div>
            <div class="log-out" @click="logout">
              <img src="@/assets/imgs/log-out.svg" alt="" />
              <span>Log out</span>
            </div>
          </div>
        </el-popover>
      </div>
    </div>

    <div class="menu-container">
      <el-scrollbar class="menu" height="100%">
        <div>
          <div class="menu-item">
            <img src="@/assets/imgs/secu.svg" alt="" />
            <div class="menu-name">Account & Security</div>
          </div>
        </div>
      </el-scrollbar>

      <div class="router-container">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onBeforeMount, reactive, inject, computed } from "vue";
import { useRouter } from "vue-router";
import { getIcon, getAppName } from "@/utils/const.js";

const router = useRouter();
const $api = inject("$api");

const accountInfo = reactive({});
const projectInfo = reactive({
  project: "",
  appid: "",
  appname: "",
});
const appName = computed(() => {
  let name = projectInfo.project;
  if (projectInfo.project === "Base") {
    if (projectInfo.appname) {
      name = projectInfo.appname;
    } else {
      name = "DMSS";
    }
  } else if (!projectInfo.project) {
    name = "DMSS";
  }
  return name;
});

const loginIcon = computed(() => {
  return getIcon(appName.value);
});
onBeforeMount(() => {
  const temp1 = JSON.parse(sessionStorage.getItem("projectInfo")) || {};
  projectInfo.project = temp1.project;
  projectInfo.appid = temp1.appid;
  projectInfo.appname = temp1.appname;
  const temp = JSON.parse(sessionStorage.getItem("loginInfo"));
  for (const key in temp) {
    if (Object.hasOwnProperty.call(temp, key)) {
      const value = temp[key];
      accountInfo[key] = value;
    }
  }
});

// 登出
const logoutLoading = ref(false);
async function logout() {
  logoutLoading.value = true;
  const res = await $api.login.logOut({ data: { clientPushId: "" } });

  sessionStorage.removeItem("loginInfo");
  logoutLoading.value = false;
  router.push({
    name: "Login",
    query: projectInfo,
  });
}
</script>

<style lang="scss" scoped>
.home {
  height: 100vh;

  .home-header {
    display: flex;
    justify-content: space-between;
    height: 5rem;
    padding-right: 2.4rem;
    align-items: center;
    background: rgb(247, 248, 250);
    border-bottom: 1px solid #dcdfe6;

    .left {
      display: flex;
      height: 100%;
      align-items: center;

      .home-icon {
        width: 6.4rem;
        background: rgb(63, 157, 255);
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;

        img {
          width: 3.2rem;
        }
      }

      .home-name {
        margin-left: 2.4rem;
        font-size: 2rem;
        font-weight: 700;
        color: rgb(107, 119, 133);
      }
    }

    .right {
      cursor: pointer;
    }
  }

  .menu-container {
    height: calc(100% - 50px);
    display: flex;

    .menu {
      height: 100%;
      flex-basis: 23rem;
      flex-shrink: 0;
      width: 0;
      padding: 0.8rem;
      border-right: 1px solid #dcdfe6;

      .menu-item {
        height: 4rem;
        display: flex;
        align-items: center;
        cursor: pointer;
        border-radius: 0.4rem;
        /* dmss */
        background: rgba(65, 156, 252, 0.08);
        padding-left: 1.8rem;
        padding-right: 1.6rem;

        img {
          margin-right: 1.4rem;
        }

        .menu-name {
          color: rgb(65, 156, 252);
          font-family: Outfit;
          white-space: nowrap;
          font-size: 1.6rem;
          font-weight: 500;
        }
      }
    }

    .router-container {
      flex-grow: 1;
      width: 0;
    }
  }
}
</style>

<style lang="scss">
.account-popper {
  .account {
    max-width: 240px;
    overflow: hidden;
    text-overflow: ellipsis;

    .account-name {
      height: 4.4rem;
      line-height: 4.4rem;
      border-bottom: 1px solid #dcdfe6;
      color: rgb(78, 89, 105);
      font-family: Outfit;
      font-size: 16px;
      font-weight: 600;
      display: flex;
      white-space: nowrap;
    }

    .log-out {
      padding-top: 1.2rem;
      display: flex;
      align-items: center;
      color: rgb(78, 89, 105);
      font-family: Outfit;
      font-size: 14px;
      font-weight: 400;
      cursor: pointer;

      img {
        margin-right: 0.4rem;
      }
    }
  }
}
</style>
